import EditorialCard from './EditorialCard';

export default EditorialCard;
